// REACT_APP_BACKEND_URL is baked in at build time. Empty = no backend (static mode).
export const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
